export class Common {
}
export interface IApplicationInfo {
    sessionID: string;
    applicationID: number;
    appRoles: number;
}

export interface IErrorMessage {
        errormessage: string;
}
export interface IUserProfile {
    lastName: string;
    firstName: string;
    userCode: string;
    userID: string;
    privilege: string;
    itApplicationRoleID: number;
    itApplicationRoleName: string;
    personID: number;
    organizationName: string;
    organizationID: number;
    organizationCode: string;
    legacyCode: string;
    organizationTypeID: number;
    systemID: string;
    systemName: string;
    schoolID: string;
    schoolName: string;
    token: string;
}
export interface IMessage {
    severity?: string;
    summary?: string;
    detail?: string;
    id?: any;
    key?: string;
    life?: number;
    sticky?: boolean;
    closable?: boolean;
    data?: any;
}
export enum IApplicationRoles {
    Administrator = 963,
    Helpdesk = 964
}
export enum enumPages {
    ChartofAccounts = 273
}
export interface IToolBarClick {
    toolbarItemId: number;
    toolbarItemName: string;
    toolbarcontrolID: number;
    isClicked: boolean;
}
export enum IWFObjectType {
    COA = 1
}

export interface IObjectStatus {
    statusID: number;
    description: string;
    updatedDate: string;
}

export interface IFiscalYear {
    fiscalYearConfigID: number;
    fiscalYear: string;
}
export interface ISearch {
    fiscalYear: number;
    fiscalYearConfigID: number;
    columnHeaderID: number;
    groupclassificationID: number;
    groupclassificationName: string;
    groupHeaderID: number;
    name: string;
}
export interface IGridPagination {
    buttonCount: number;
    info: boolean;
    type: any;
    pageSizes: boolean;
    previousNext: true;
    gridPageSize: number;
}
